App.controller('setupWorkingHours', ($rootScope, $scope, $q, $api, Perm, NgTableParams, ngDialog, responseHelper, datesInTimezone) => {

  $scope.working_hours_options_every_day = "Every day"

  $scope.loading_working_hours = false
  $scope.deferred_load = $q.defer()

  $scope.tableParams = new NgTableParams({count: 10}, {
    getData(tparams) {
      return $scope.deferred_load.promise.then( () => {
        $scope.loading_working_hours = true

        opts = {
          location_id: $scope.location.id,
          page: tparams.page(),
          per_page: tparams.count()
        }
        // $scope.member.uuid for operatories, $scope.member.id for providers(providers don't have uuid)
        return $api('GET', `/${$scope.members_wording}/${$scope.member.uuid || $scope.member.id}/working_hours`, opts).then((resp) => {
          $scope.working_hours = $scope.groupWorkingHours(resp.data.data)
          $scope.loading_working_hours = false
          tparams.total(resp.data.count)
          return $scope.working_hours
        })
      })
    }
  })

  Perm.perm_promise.then( () => {
    $scope.tableParams.reload()
    $scope.loading_working_hours = false
    $scope.deferred_load.resolve(true)
  })

  $scope.$on('loc_change', () => {
    $scope.tableParams.reload()
  })

  $scope.getAppointmentTypesDefaultsLabel = () => {
    return $scope.memberIsOperatory() ? 'Operatory defaults' : 'Provider defaults'
  }

  // Bounded series read top-down: what applies now, what is coming, what is over.
  BOUNDS_STATE_RANK = { active: 0, upcoming: 1, ended: 2 }

  $scope.groupWorkingHours = (data) => {
    formatted_working_hours = $scope.formatWorkingHoursData(data)
    grouped_working_hours = _.groupBy(formatted_working_hours, wh => wh.group)
    groups = _.map(grouped_working_hours, (whs) => {
      wh = whs[0]
      const start = new Date(wh.begin_time)
      const end = new Date(wh.end_time)
      const diff = (end.getTime() - start.getTime())
      const duration = Math.round(diff / 60000) // minutes;
      const atypes_with_longer_durations = (wh.appointment_types || []).filter(wh_at => {
        const provider_at = findApptTypeByCategoryId(
          appointmentTypesByProviderId(wh.parent_id),
          wh_at.appt_category.id
        )
        if (provider_at && provider_at.minutes) return provider_at.minutes > duration

        return (wh_at.minutes || wh_at.appt_category.minutes) > duration
      })

      group = {
        warning: atypes_with_longer_durations.length ? `The following appointment types have a duration longer than the working time block and won't be available in online booking:  ${$scope.toSentence(atypes_with_longer_durations, 'name', 3)}` : null,
        label: wh.label,
        label_members_table: wh.label_members_table,
        display_time_range: wh.display_time_range,
        begin_time_in_tz: wh.begin_time_in_tz,
        end_time_in_tz: wh.end_time_in_tz,
        toggle_on_date: wh.toggle_on_date,
        toggle_every: wh.toggle_every,
        every_label: wh.every_label,
        date_range_label: wh.date_range_label,
        bounds_state: wh.bounds_state,
        bounds_note: wh.bounds_note,
        last_synced_label: wh.last_synced_label,
        appointment_types_label: $scope.toSentence(wh.appointment_types, 'name', 3, $scope.getAppointmentTypesDefaultsLabel()),
        synced: _.every(whs, 'non_editable'),
        working_hours: whs
      }
      return group
    })

    return _.sortBy(groups, group => BOUNDS_STATE_RANK[group.bounds_state] || 0)
  }

  appointmentTypesByProviderId = (providerId) => {
    if (!$scope.memberIsProvider()) return []

    const provider = $scope.memberById(providerId)
    if (!provider) return []

    return provider.appointment_types || []
  }

  findApptTypeByCategoryId = (appt_types, category_id) => {
    return appt_types.find(
      appt_type => appt_type.appt_category.id === category_id
    )
  }

  $scope.formatWorkingHoursData = (data) => {
    if (!data) { return data }

    _.each(data, (wh) => {
      if (wh.foreign_id_type != 'nex') {  wh.non_editable = true }
      $scope.formatWorkingHoursDates(wh)
      $scope.enableWorkingHoursToggles(wh)
      $scope.setWorkingHourLabel(wh)
      $scope.setWorkingHourBounds(wh)
      $scope.setWorkingHourSyncLabel(wh)
      $scope.setWorkingHourGroup(wh)
    })

    return data
  }

  $scope.formatWorkingHoursDates = (wh) => {
    if(wh.begin_time){
      wh.begin_time_in_tz = convertTzAndSplitDate(wh.display_time_range.split(" - ")[0])
    }
    if(wh.end_time){
      wh.end_time_in_tz = convertTzAndSplitDate(wh.display_time_range.split(" - ")[1])
    }
  }

  convertTzAndSplitDate = (time) => {
    time_in_tz = moment(time, "hh:mm A")
    return {
      hour: time_in_tz.format("hh"),
      minute: time_in_tz.format('mm'),
      meridian: time_in_tz.format('A')
    }
  }

  $scope.enableWorkingHoursToggles = (wh) => {
    if(wh.misc && wh.misc.on_date){
      wh.toggle_on_date = true
    }
    if(wh.misc && wh.misc.every){
      wh.toggle_every = true
    }
  }

  $scope.setWorkingHourLabel = (wh) => {
    if(wh.toggle_on_date && wh.misc && wh.misc.on_date){
      wh.label_members_table = moment(wh.misc.on_date, "YYYY-MM-DD").format('MMM D, YYYY')
      return
    }

    if(wh.toggle_every){
      if($scope.isRepeatedEveryDay(wh)){
        wh.label_members_table = $scope.working_hours_options_every_day
      } else if(wh.toggle_every && wh.misc && wh.misc.every && wh.misc.every.ref){
        wh.label_members_table = moment(wh.misc.every.ref, "YYYY-MM-DD").format('MMM D, YYYY')
        wh.every_label = `Every ${wh.misc.every.num} ${wh.misc.every.unit}`
        if (wh.misc.every.num > 1) {
          wh.every_label += 's' // pluralize unit
        }
        if (wh.misc.every.unit === 'week') {
          wh.every_label += ' on ' + moment(wh.misc.every.ref, "YYYY-MM-DD").format('ddd')
        }
      }
      return
    }

    if(wh.misc && wh.misc.days && wh.misc.days.length){
      weekdays = _.map(wh.misc.days, wd => {return getShortWeekdayName(wd)})
      label_members_table = weekdays.join(', ')
      label = label_members_table
    } else {
      label_members_table = getShortWeekdayName(wh.day)
      label = wh.day
    }
    wh.label_members_table = label_members_table
    wh.label = label
  }

  // start_date/end_date come from the EHR on synced recurring series. Both are plain
  // office-local dates and end_date is inclusive, so a series ending today is still live.
  // Compare in the practice timezone, not the viewer's, or a staff member in another
  // timezone sees a bound flip a day early or late near midnight.
  $scope.setWorkingHourBounds = (wh) => {
    if(!wh.start_date && !wh.end_date){ return }

    const today = moment.tz(new Date, $rootScope.timezone).startOf('day')
    const start = wh.start_date ? moment.tz(wh.start_date, "YYYY-MM-DD", $rootScope.timezone) : null
    const end = wh.end_date ? moment.tz(wh.end_date, "YYYY-MM-DD", $rootScope.timezone) : null

    if(start && end){
      wh.date_range_label = `${start.format('MMM D, YYYY')} – ${end.format('MMM D, YYYY')}`
    } else if(start){
      wh.date_range_label = `starting ${start.format('MMM D, YYYY')}`
    } else {
      wh.date_range_label = `through ${end.format('MMM D, YYYY')}`
    }

    if(end && end.isBefore(today)){
      wh.bounds_state = 'ended'
      wh.bounds_note = `Ended ${end.format('MMM D, YYYY')}`
      return
    }

    if(start && start.isAfter(today)){
      wh.bounds_state = 'upcoming'
      wh.bounds_note = start.diff(today, 'days') == 1 ? 'Starts tomorrow' : `Starts ${start.format('MMM D, YYYY')}`
      return
    }

    wh.bounds_state = 'active'
    if(end && end.isSame(today)){
      wh.bounds_note = 'Ends today'
    }
  }

  $scope.setWorkingHourSyncLabel = (wh) => {
    if(!wh.non_editable || !wh.last_sync_time){ return }

    wh.last_synced_label = `Last change detected ${moment(wh.last_sync_time).format('MMM D, YYYY, h:mm A')}`
  }

  getShortWeekdayName = (weekday_name) => {
    weekday_index = moment.weekdays().findIndex(wd => wd == weekday_name)
    short_weekday = moment.weekdaysShort()[weekday_index]
    return short_weekday
  }

  $scope.isRepeatedEveryDay = (wh) => {
    return wh.misc && wh.misc.every && wh.misc.every.unit == 'day' && wh.misc.every.num == 1
  }

  $scope.setWorkingHourGroup = (wh) => {
    appt_types = _.map(wh.appointment_types, (at) => at.appt_category.id).sort().join('-')
    group = [wh.label, wh.label_members_table,
             wh.begin_time_in_tz.hour, wh.begin_time_in_tz.minute, wh.begin_time_in_tz.meridian,
             wh.end_time_in_tz.hour, wh.end_time_in_tz.minute, wh.end_time_in_tz.meridian,
             wh.toggle_on_date, wh.toggle_every, wh.every_label,
             wh.start_date, wh.end_date, appt_types]
    if ($scope.location.map_by_operatory && !$scope.location.appt_types_map_by_operatory) {
      wh.group = group
    } else {
      group.push(wh.operatory_uuid || wh.id)
      wh.group = group
    }
  }

  $scope.addWorkingHours = () => {
    today = moment.tz(new Date, $rootScope.timezone).startOf('day')
    begin_time = angular.copy(today)
    end_time = angular.copy(today)
    begin_time.set({hour: 9})
    end_time.set({hour: 17})

    if ($scope.memberIsOperatory()) {
      parent_id = null
    } else {
      parent_id = $scope.member.id
    }

    wh = {
      active: true,
      institution_id: $rootScope.institution.id,
      location_id: $scope.location.id,
      begin_time: begin_time.toISOString(),
      end_time: end_time.toISOString(),
      misc: {},
      parent_id: parent_id,
      parent_type: 'User',
      appointment_types: [],
      display_time_range: "9:00 AM - 5:00 PM"
    }

    $scope.formatWorkingHoursDates(wh)
    $scope.workingHoursPopup('Add Time for', [wh])
  }

  $scope.editWorkingHours = (working_hours) => {
    $scope.workingHoursPopup('Edit Time for', angular.copy(working_hours))
  }

  // A clone is a brand new, NexHealth-owned working hour: drop everything that marks the
  // original as EHR-managed, otherwise the draft renders as synced and `saveWorkingHours`
  // filters it out as non_editable.
  SYNC_ATTRIBUTES = ['foreign_id', 'foreign_id_type', 'last_sync_time', 'last_synced_label',
                     'non_editable', 'start_date', 'end_date', 'date_range_label',
                     'bounds_state', 'bounds_note']

  $scope.cloneWorkingHours = (working_hours) => {
    cloned_working_hours = angular.copy(working_hours)
    _.each(cloned_working_hours, (wh) => {
      delete wh.id
      _.each(SYNC_ATTRIBUTES, (attribute) => {
        delete wh[attribute]
      })
      _.each(wh.appointment_types, (appt_type) => {
        delete appt_type.id
      })
    })
    $scope.workingHoursPopup('Add Time for', cloned_working_hours)
  }

  $scope.workingHoursPopup = (title, working_hours) => {
    opts = {
      template: '/app/views/setup/tabs/availability/working-hours-popup.html',
      className: 'ne__modal ne__modal--online-booking',
      controller: 'setupWorkingHoursPopup',
      scope: $scope,
      data: { title, working_hours }
    }
    const dialog = ngDialog.open(opts)
    dialog.closePromise.then(d => {
      if (d.value.saved) {
        $scope.tableParams.reload()
      }
    })
  }

  $scope.destroyWorkingHours = (working_hours) => {
    dialog = $rootScope.confirm_modal({
      text: `Are you sure you want to delete this schedule?`,
      custom_confirm: "Delete"
    })
    dialog.closePromise.then(data => {
      if (data.value == true) {
        _.each(working_hours, (wh) => {
          wh._destroy = true
        })
        $scope.saveWorkingHours(working_hours, () => $scope.tableParams.reload())
      }
    })
  }

  $scope.saveWorkingHours = (working_hours, onSuccess) => {
    editable_working_hours = working_hours.filter((wh) => { return !wh.non_editable })
    if (!editable_working_hours.length) { return $scope.updateAppointmentTypes(working_hours, onSuccess) }

    formatBeforeSave(editable_working_hours)

    if (!validateWorkingHours(editable_working_hours)) {
      return
    }

    working_hours_opts = _.map(editable_working_hours, (wh) => {
      return _.pick(wh, 'id', 'institution_id', 'location_id', 'day', 'parent_id', 'parent_type',
                        'begin_time', 'end_time', 'misc', '_destroy', 'operatory', 'appointment_types_attributes')
    })
    if(!working_hours_opts.length){
      // workaround to send empty array (otherwise angular remove that attribute from the request)
      working_hours_opts = [""]
    }

    save_opts = { location_id: $scope.location.id }
    wh_opts = { working_hours_attributes: working_hours_opts }

    if ($scope.memberIsOperatory()) {
      save_opts['operatory'] = wh_opts
      recipient_wording = 'providers of this operatory'
    } else {
      save_opts['provider'] = wh_opts
      recipient_wording = 'this provider'
    }

    $scope.saveRequest(save_opts, onSuccess)
  }

  // 'non-editable' working hours should still be able to update the associated appointment_types, but not the availability
  $scope.updateAppointmentTypes = (workingHours, onSuccess) => {
    const working_hours_attributes = workingHours.map(({id, misc, day, appointment_types_attributes}) => {
     return { id, misc, day, appointment_types_attributes }
    });
    const rootKey = $scope.memberIsOperatory()? 'operatory' : 'provider'
    const opts = {
      location_id: $scope.location.id,
      [rootKey]: { working_hours_attributes }
    }
    $scope.saveRequest(opts, onSuccess)
  }

  $scope.saveRequest = (opts, onSuccess) => {
    $scope.saving_working_hours = true
    // $scope.member.uuid for operatories, $scope.member.id for providers(providers don't have uuid)
    $api('PUT', `/${$scope.members_wording}/${$scope.member.uuid || $scope.member.id}`, {}, opts).then((resp) => {
      if(resp.data.code){
        if (onSuccess) {
          onSuccess()
        }
      }
      resp.$response = resp
      responseHelper.redirectOrToastOnResp(resp)
      $scope.saving_working_hours = false
    })
  }

  isCustomRepeatChanged = () => {
    is_changed = false
    _.each($scope.member.working_hours, (wh) => {
      if(wh.misc && wh.misc.every){
        if(!wh.id){ // new working hour
          is_changed = true
          return false
        } else { // existing working hour
          init_wh = _.filter($scope.member.initial_working_hours, (init_wh) => {return init_wh.id == wh.id})[0]
          if(!init_wh.misc || !init_wh.misc.every || init_wh.misc.every.ref != wh.misc.every.ref || init_wh.misc.every.num != wh.misc.every.num || init_wh.misc.every.unit != wh.misc.every.unit){
            is_changed = true
            return false
          }
        }
      }
    })
    return is_changed
  }

  formatBeforeSave = (editable_working_hours) => {
    _.each(editable_working_hours, (wh) => {
      // remove misc.on_date if 'on a specific date' is disabled
      if(wh.misc && wh.misc.on_date && !wh.toggle_on_date){
        delete wh.misc.on_date
      }
      // remove misc.every if 'custom repeat' is disabled
      if(wh.misc && wh.misc.every && !wh.toggle_every){
        delete wh.misc.every
      }
      // format begin/end dates
      wh.begin_time = combineDate(wh.begin_time_in_tz)
      wh.end_time = combineDate(wh.end_time_in_tz)
      $scope.formatWorkingHoursDates(wh)
    })
  }

  combineDate = (time) => {
    current_date = moment().tz($rootScope.timezone).format("YYYY-MM-DD")
    moment_time = moment(`${current_date} ${time.hour}:${time.minute} ${time.meridian}`, "YYYY-MM-DD hh:mm A")
    moment_time = moment.tz(moment_time, $rootScope.timezone)

    inst_offset =
      datesInTimezone.getTimezoneOffset(
        moment().tz($rootScope.timezone).toDate(),
        $rootScope.timezone,
        false
      ) * 60

    client_offset = moment().utcOffset()
    moment_time.add(- inst_offset + client_offset, 'minutes')
    return moment_time.toISOString()
  }

  validateWorkingHours = (editable_working_hours) => {
    validation = true

    _.each(editable_working_hours, (wh) => {
      if($scope.memberIsOperatory() && wh.provider && wh.provider.id) {
        wh.parent_id = wh.provider.id
      }
      if(wh._destroy){ return }
      errors = []
      if($scope.location.map_by_operatory && !$scope.location.appt_types_map_by_operatory && (!wh.operatory || !wh.operatory.uuid)){
        errors.push("Please choose an operatory")
      }
      if($scope.memberIsOperatory() && (!wh.provider || !wh.provider.id)){
        errors.push("Please choose a provider")
      }
      if(wh.toggle_on_date && (!wh.misc || !wh.misc.on_date)){
        errors.push("Please choose a specific date")
      }
      if(wh.toggle_on_date && wh.misc && wh.misc.on_date && moment(wh.misc.on_date) < moment().startOf('day')){
        errors.push("Please choose a date in future")
      }
      if(wh.toggle_every && (!wh.misc || !wh.misc.every || !wh.misc.every.ref)){
        errors.push("Please choose a reference date")
      }
      if(!wh.day && !wh.toggle_on_date && !wh.toggle_every && (!wh.misc || (!wh.misc.days && !wh.misc.every))) {
        errors.push("Please choose a weekday")
      }
      if(!wh.begin_time || !wh.end_time) {
        errors.push("Please choose both begin and end time")
      }
      if(moment(wh.begin_time) >= moment(wh.end_time)) {
        errors.push("Begin time should be less than an end time")
      }
      if(errors.length){
        validation = false
        wh.errors = errors
      }
    })
    return validation
  }

  $scope.setDisplayNameForProviders = (providers) => {
    _.each(providers, (p) => {
      if (p.display_name) return;

      if (p.name) {
        p.display_name = p.name;
      } else {
        p.display_name = `${p.first_name} ${p.last_name}`;
      }
    })
  }

  $scope.setDisplayNameForOperatories = (operatories) => {
    _.each(operatories, (o) => {
      if (o.display_name === o.name) { return }

      if (!o.display_name || o.display_name === '') {
        o.display_name = o.name
      }
    })
  }

  $scope.memberColumnTitle = () => {
    if($scope.memberIsOperatory()) {
      return 'Provider'
    } else {
      return 'Operatories'
    }
  }

  $scope.memberColumn = (working_hour) => {
    if($scope.memberIsOperatory()) {
      const providers = _.map(working_hour.working_hours, (wh) => wh.provider || {})
      $scope.setDisplayNameForProviders(providers)
      return $scope.toSentence(_.uniqBy(providers, 'id'), 'display_name', 3)
    } else {
      const operatories = _.map(working_hour.working_hours, (wh) => wh.operatory || {})
      $scope.setDisplayNameForOperatories(operatories)
      return $scope.toSentence(_.uniqBy(operatories, 'uuid'), 'display_name', 3)
    }
  }
})
